"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGRSLEN = exports.PREHASH_LEN = exports.PRINCIPAL_LEN = exports.ADDRLEN = exports.PKLEN = exports.SIGN_VALUES_P2 = exports.APP_KEY = void 0;
exports.APP_KEY = "ICP";
exports.SIGN_VALUES_P2 = {
    DEFAULT: 0x00,
    STAKE_TX: 0x01,
};
exports.PKLEN = 65;
exports.ADDRLEN = 32;
exports.PRINCIPAL_LEN = 29;
exports.PREHASH_LEN = 43;
exports.SIGRSLEN = 64;
